import { Controller } from "@hotwired/stimulus";

// Drives the segmented control that switches between the 5 resource_types
// inside the "Champs personnalises" section. Active tab is mirrored in
// `localStorage` so the user lands on the same resource on next visit, and
// in a `cf-resource` URL search-param so server redirects can also target
// the right tab.
export default class extends Controller {
  static targets = ["tab", "panel"];
  static values  = { active: { type: String, default: "Etude" } };

  connect() {
    const stored = this._storedActive();
    const initial = stored || this.activeValue;
    this._activate(initial);
  }

  switch(event) {
    event.preventDefault();
    const resource = event.currentTarget.dataset.resourceType;
    if (!resource) return;
    this._activate(resource);
    this._storeActive(resource);
  }

  openNew(event) {
    event.preventDefault();
    const active = this._currentActive();
    const link = document.createElement("a");
    link.href = this._newUrlFor(active);
    link.setAttribute("data-turbo-frame", "cf_modal_frame");
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  _activate(resource) {
    this.activeValue = resource;
    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.resourceType === resource;
      tab.classList.toggle("cf-tabs__tab--active", on);
      tab.setAttribute("aria-selected", on ? "true" : "false");
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.resourceType !== resource;
    });
  }

  _currentActive() {
    return this.activeValue || "Etude";
  }

  _newUrlFor(resourceType) {
    // We rely on the fact that the "Nouveau champ" CTA is always anchored
    // inside an element that exposes the base URL of the section through
    // the first card edit link. Falling back to relying on the page-wide
    // helper inserted at render time would couple us to global state, so
    // instead we look up the action attribute of any existing form.
    const existing = document.querySelector(".cf-card__action[data-turbo-frame='cf_modal_frame']");
    if (existing) {
      // Replace .../custom_field_definitions/:id/edit -> .../new?resource_type=Foo
      const href = existing.getAttribute("href");
      const base = href.replace(/\/[0-9]+\/edit$/, "/new");
      return `${base}?resource_type=${encodeURIComponent(resourceType)}`;
    }
    // Fallback: scan for the move-url template on the list controller
    const list = document.querySelector("[data-custom-fields-list-move-url-template-value]");
    if (list) {
      const tpl = list.getAttribute("data-custom-fields-list-move-url-template-value");
      const base = tpl.replace(/\/PLACEHOLDER\/move$/, "/new");
      return `${base}?resource_type=${encodeURIComponent(resourceType)}`;
    }
    return "#";
  }

  _storageKey() {
    return "jc:customFields:activeResource";
  }

  _storedActive() {
    try { return window.localStorage.getItem(this._storageKey()); }
    catch (_e) { return null; }
  }

  _storeActive(resource) {
    try { window.localStorage.setItem(this._storageKey(), resource); }
    catch (_e) { /* ignore */ }
  }
}
